import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const INFORMATIONSTEXTBLOCK_LEGACY_FIELD_ORDER = [
  "content"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  informationsTextBlockDescriptor: _generatedInformationsTextBlockDescriptor,
  informationsTextBlockBlocDefinition,
  informationsTextBlockDashboardLayout,
  informationsTextBlockConfig,
  informationsTextBlockResolveConfig,
  informationsTextBlockProperties,
} = doodBlockConfig(
  {
    name: "Informations Text",
    componentType: 'InformationsTextBlockComponent',
    category: 'content',
    hideFromPicker: true,
    description: "Informations Text.",
    keywords: [],
    allowedIn: [
      { bloc: "InformationsContainerBlockComponent", slot: "columns" },
    ],
    sharedFields: {}
  },

  () => ({
    content: propertyValue({
      type: 'wysiwyg',
      value: '',
      options: {
        label: "pages.blocks.informations-text.content.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.informations-text.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.informations-text.fieldset.text.label",
            fields: ["content"],
          },
        ],
      },
    ],
  })
);

export function informationsTextBlockDescriptor(): IBlockDescriptor;
export function informationsTextBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function informationsTextBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedInformationsTextBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedInformationsTextBlockDescriptor, informationsTextBlockProperties, fieldOrder);
}

export {
  informationsTextBlockBlocDefinition,
  informationsTextBlockDashboardLayout,
  informationsTextBlockProperties,
  informationsTextBlockConfig,
  informationsTextBlockResolveConfig,
};

export type InformationsTextBlockConfig = typeof informationsTextBlockConfig;
